import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Specular$dCallback from "../Specular.Callback/index.js";
import * as Specular$dDom$dBrowser from "../Specular.Dom.Browser/index.js";
import * as Specular$dDom$dBuilder from "../Specular.Dom.Builder/index.js";
import * as Specular$dDom$dElement from "../Specular.Dom.Element/index.js";
import * as Specular$dFRP$dBase from "../Specular.FRP.Base/index.js";
import * as Specular$dFRP$dReplaceable from "../Specular.FRP.Replaceable/index.js";
import * as Specular$dInternal$dRIO from "../Specular.Internal.RIO/index.js";
const whenNothingD = dyn => content => Specular$dFRP$dReplaceable.whenD({
  MonadEffect0: () => Specular$dInternal$dRIO.monadEffectRIO,
  MonadCleanup1: () => Specular$dDom$dBuilder.monadCleanupBuilder
})(Specular$dDom$dBuilder.monadReplaceBuilder)(Specular$dFRP$dBase.functorDynamic.map(Data$dMaybe.isNothing)(dyn))(content);
const onSubmitPreventDefault_ = cb => Specular$dDom$dElement.on("submit")(x => {
  const $0 = Specular$dDom$dBrowser.preventDefault(x);
  const $1 = cb();
  return () => {
    $0();
    $1();
  };
});
const onClickPreventDefault_ = cb => Specular$dDom$dElement.onClick(x => {
  const $0 = Specular$dDom$dBrowser.preventDefault(x);
  const $1 = cb();
  return () => {
    $0();
    $1();
  };
});
const gateEvent = dyn => event => Specular$dFRP$dBase.filterMapEvent(x => x)(Specular$dFRP$dBase.attachDynWith(dynValue => evt => {
  if (dynValue) { return Data$dMaybe.$Maybe("Just", evt); }
  return Data$dMaybe.Nothing;
})(dyn)(event));
const gateCallback = dyn => cb => Specular$dCallback.contramapCallbackDynMaybe(Specular$dFRP$dBase.functorDynamic.map(v => {
  if (v) { return Data$dMaybe.Just; }
  return v$1 => Data$dMaybe.Nothing;
})(dyn))(cb);
export {gateCallback, gateEvent, onClickPreventDefault_, onSubmitPreventDefault_, whenNothingD};
